var _a;
export var RTL_LOCALES = [
    "ar",
    "arc",
    "dv",
    "fa",
    "ha",
    "he",
    "khw",
    "ks",
    "ku",
    "ps",
    "ur",
    "yi",
];
var DEBUG = false;
if (typeof process !== "undefined") {
    DEBUG = !!(((_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.NODE_ENV) === "development" &&
        !process.env.DISABLE_TARGEM_WARNINGS);
}
export { DEBUG };
//# sourceMappingURL=constants.js.map